import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false,
    },
    device: 'desktop',
    phone:'13950677365',
    isperfectmsg:'',
    perimess:[],
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1);
      } else {
        Cookies.set('sidebarStatus', 0);
      }
      state.sidebar.opened = !state.sidebar.opened;
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    TOGGLE_PHONE:(state,phone)=>{
      state.phone=phone;
    },
    TOGGLE_ISPERFECMSG:(state,isperfectmsg)=>{
      state.isperfectmsg=isperfectmsg;
    },
    TOGGLE_PERIMESS:(state,perimess)=>{
      state.perimess=perimess;
    },
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR');
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device);
    },
    TogglePhone({ commit }, phone ){
      commit('TOGGLE_PHONE',phone);
    },
    IsPerfectMsg({commit},isperfectmsg){
      commit('TOGGLE_ISPERFECMSG',isperfectmsg);
    },
    Toggleperimess({commit},perimess){
      commit('TOGGLE_PERIMESS',perimess);
    },
  }
}

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js